import { ProductTypeEnum } from "../../enums/ProductTypeEnum";
import { ProductCategoryInterface } from "../../interfaces/apiV2/shared/ProductCategoryInterface";

/** Root category codes excluded from the machinery ("products") product range. */
const NON_MACHINERY_CATEGORY_CODES = new Set([
    ProductTypeEnum.accessories,
    "spareparts",
    "old_models",
]);

export const filterCategoriesByProductType = (
    categories: ProductCategoryInterface[],
    productType: ProductTypeEnum,
): ProductCategoryInterface[] => {
    if (productType === ProductTypeEnum.accessories) {
        return categories.filter(
            (category) => category.code === ProductTypeEnum.accessories,
        );
    }

    return categories.filter(
        (category) => !NON_MACHINERY_CATEGORY_CODES.has(category.code),
    );
};
